import { List } from "devextreme-react";
import Drawer from 'devextreme-react/drawer';

import { useAuth } from "../auth/auth-provider/auth-provider";
import { useEffect, useState } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import ProfileList from "../profile/profile-list/profile-list";
import NotificationList from "../notification/notification-list/notification-list";
import GeoAreaList from "../geo-area/geo-area-list/geo-area-list";
import GoldPriceTab from "../gold-price/gold-price-tab/gold-price-tab";
import TransactionTabs from "../transaction/transaction-tabs";
import CommunicationWithServer from "../communication-with-server/communication-with-server";
import ProfileDetail from "../profile/profile-detail/profile-detail";
import ProfileEdit from "../profile/profile-edit/profile-edit";
import { useOpenDrawer } from "../custom-providers/open-drawer-provider/open-drawer-provider";
import { PrivateRoute } from "../auth/private-route/private-route";
import { AdminRoute } from "../auth/admin-route/admin-route";
import QuantityDefinitionPage from "../quantity-definition/quantity-definition-page/quantity-definition-page";
import AccountBalanceReport from "../report/account-balance-report/account-balance-report";
import GoldTradingPlatform from "../gold-trading-platform/GoldTradingPlatform";
import { adminNavigationList, userNavigationList } from "./drawer-routes";
import ReceiptPage from "../receipt/receipt-page/ReceiptPage";
import PurchasingPowerTab from "../purchasing-power/purchasing-power-tab/purchasing-power-tab";
import UserAccounting from "../accounting/user-accounting/user-accounting";
import ReceiptEdit from "../receipt/receipt-edit/receipt-edit";
import TransactionDetail from "../transaction/transaction-detail/TransactionDetail";
import NewProfile from "../profile/new-profile/NewProfile";
import AdminMessageList from "../admin-message/admin-message-list/AdminMessageList";
import { persianLanguage } from "../../constants/persianTerms";
import "./drawer-menu.css";
import InCallOrderDetail from "../gold-price/user-orders/incall-order-detail/InCallOrderDetail";
import InPersonOrderDetail from "../gold-price/user-orders/inperson-order-detail/InPersonOrderDetail";
import ReceiveOrDeliverOrderDetail from "../gold-price/user-orders/receive-or-deliver-order-detail/ReceiveOrDeliverOrderDetail";
import TransactionHistoryList from "../transaction/transaction-list/transaction-history-list/transaction-history-list";
import TransactionAwaitingList from "../transaction/transaction-list/transaction-awaiting-list/transaction-awaiting-list";
import TransactionHistoryReport from "../report/transaction-history-report/TransactionHistoryReport";
import GoldDataSourceList from "../gold-data-source/gold-data-source-list/GoldDataSourceList";
import QuantityDefinitionDetail from "../quantity-definition/quantity-definition-detail/QuantityDefinitionDetail";
import PartnerList from "../partner/partner-list/PartnerList";
import PartnerDetail from "../partner/partner-detail/PartnerDetail";
import GoldDataSourceDetail from "../gold-data-source/gold-data-source-detail/GoldDataSourceDetail";
import SiteSettingsList from "../site-settings/site-settings-list/SiteSettingsList";
import GoldPriceHistory from "../gold-price/gold-price-history/GoldPriceHistory";


export default function DrawerMenu(){
    const navigate = useNavigate(); 
    const auth = useAuth();
    const {opened, setOpened} = useOpenDrawer();
    const [navigation, setNavigation] = useState([]);
    const [navigationStack, setNavigationStack] = useState([]);
    const [currentItems, setCurrentItems] = useState([]);

    const navigateToSubmenu = (items) => {
        setNavigationStack(prev => [...prev, currentItems]);
        setCurrentItems(items);
    };


    const navigateBack = () => {
        if (navigationStack.length > 0) {
            const previousItems = navigationStack[navigationStack.length - 1];
            setNavigationStack(navigationStack.slice(0, -1));
            setCurrentItems(previousItems);
        }
    };

    useEffect(() => {
        if (navigation.length) {
            setCurrentItems(navigation);
            setNavigationStack([]);
        }
    }, [navigation]);

    const relaodForNewHash = () => {
        setTimeout(() => {
            window.location.reload();
            window.location.reload();
        }, 2000);
    }

    const getHash = async () => {
        const response = await fetch('/');
        const html = await response.text();
        const match = html.match(/main\.(\w+)\.js/); // Extract hash from filename
      
        if (match) {
            const oldHash = localStorage.getItem('hashValue') || "";
            if (oldHash === match[1]){
            } else {
                localStorage.removeItem('hashValue');
                localStorage.setItem('hashValue', match[1]);
                relaodForNewHash();
            }
        }
        else {
        }
    }
      
    useEffect(() => {
        getHash();
        if(auth?.user?.isAdmin === true){
            setNavigation(adminNavigationList);
        } else if (auth?.user?.isAdmin === false) {
            setNavigation(userNavigationList);
        } else {
            setNavigation([]);
        }
    }, [opened])

    const renderItem = (data) => {
        return (
            <div 
                className={data.className} 
                onClick={() => {
                    if (data.items) {
                        navigateToSubmenu(data.items);
                    } else {
                        navigate(data.path);
                        // setTimeout(() => setOpened(false), 100);
                    }
                }}
            >
                <div>
                    <div className="dx-list-item-icon-container">
                        <i className={`dx-icon dx-list-item-icon dx-icon-${data.icon}`} />
                    </div>
                    <span>{data.text}</span>
                    {data.items && (
                        <i className="dx-icon dx-icon-chevronright" style={{ float: 'left' }} />
                    )}
                </div>
            </div>
        );
    };

    const renderList = () => {
        const itemsToRender = currentItems.length ? currentItems : navigation;
        
        return (
            <div className="nested-drawer-container">
                {navigationStack.length > 0 && (
                    <div className="drawer-back-button" onClick={navigateBack}>
                        <i className="dx-icon dx-icon-chevronleft" />
                        <span className="golden">{persianLanguage.word.general.RETURN}</span>
                    </div>
                )}
                
                <List
                    items={itemsToRender}
                    width={200}
                    selectionMode="single"
                    // onSelectionChanged={() => setTimeout(() => setOpened(false), 100)}
                    itemRender={renderItem}
                />
            </div>
        );
    };

    return (<>
        <div className="flex-container">
            {/* <Drawer 
                opened={opened}
                openedStateMode="shrink"
                position='right'
                selectionMode="single"
                revealMode="slide"
                rtlEnabled={true}
                render={renderList}
            > */}
                <div id="view">
                    {auth?.token &&
                        <div className="container">
                            <div className="grid grid-cols-1 gap-1 sm:grid-cols-1 md:gap-1">
                                {/* <CommunicationWithServer/> */}
                                {/* <UserAccountBalance /> */}
                            </div>
                        </div>                    
                    }
                    {/* <ProfileEditName /> */}
                    <Routes>
                        <Route element={<PrivateRoute />}>
                            <Route exact path="/" element={<GoldPriceHistory />} />
                            {/* <Route path="/trading-platform" element={<GoldTradingPlatform/>}/> */}
                            {/* <Route path="/transactions" element={<TransactionTabs />} /> */}
                            {/* <Route path="/transactions/:transactionId" element={<TransactionDetail />} />
                            <Route path="/receipts" element={<ReceiptPage />} />
                            <Route path="/notifications" element={<NotificationList />} />
                            <Route path='/profiles/new' element={<NewProfile/>} />
                            <Route path='/profiles/:profileId/accounting' element={<UserAccounting />} />
                            <Route path="/in-call-orders/:orderId" element={<InCallOrderDetail />} />
                            <Route path="/in-person-orders/:orderId" element={<InPersonOrderDetail />} />
                            <Route path="/receive-or-deliver-orders/:orderId" element={<ReceiveOrDeliverOrderDetail />} />
                            <Route path='/receipts/new' element={<ReceiptEdit/>} /> */}
                            {/* <Route
                            path="/profiles/:profileId"
                            element={<ProfileDetail/>}
                            ></Route>
                            <Route
                            path="/profiles/:profileId/edit"
                            element={<ProfileEdit/>}
                            ></Route>
                            <Route
                                path="/reports"
                                element={<TransactionHistoryReport/>}
                            ></Route> */}
                            <Route element={<AdminRoute />}>
                                {/* <Route path="/quantity-definitions" element={<QuantityDefinitionPage />} />
                                <Route path="/quantity-definitions/:quantityDefinitionId" element={<QuantityDefinitionDetail />} />
                                <Route path="/geo-areas" element={<GeoAreaList />} />
                                <Route path="/admin-messages" element={<AdminMessageList />} />    
                                <Route path="/profiles" element={<ProfileList />} />     */}
                                {/* <Route path="/gold-data-sources" element={<GoldDataSourceList />} /> */}
                                {/* <Route
                                path="/users/:profileId/purchasing-power"
                                element={<PurchasingPowerTab />}
                                ></Route> */}
                                {/* <Route path="/awaiting-transactions" element={<TransactionAwaitingList />} />
                                <Route path="/transactions-history" element={<TransactionHistoryList />} />
                                <Route path="/register-factor" element={<GoldPriceTab />} />
                                <Route path="/site-settings" element={<SiteSettingsList />} />
                                <Route path="/gold-data-sources/:code" element={<GoldDataSourceDetail/>} /> */}
                            </Route>
                        </Route>
                    </Routes>
                </div>
            {/* </Drawer> */}
        </div>
    </>);
}